import localforage from 'localforage'
import moment from 'moment'

const timeout = 60 * 24
const ERPLOOKUPKEY = 'ERPLOOKUP'
const ERPLOOKUPTIMEKEY = 'ERPLOOKUPTIME'

export const hasLookUpInWindow = function () {
  try {
    const lookupDB = localforage.createInstance({ name: 'lookup' })
    if (window.__ERPLOOKUP__) {
      // set lookup indexDB
      lookupDB.setItem(ERPLOOKUPKEY, window.__ERPLOOKUP__)
      lookupDB.setItem(ERPLOOKUPTIMEKEY, new Date())
      console.info('【ERP】:cache lookup success ')
    } else {
      // get lookup indexDB and set in window
      lookupDB.getItem(ERPLOOKUPTIMEKEY).then(res => {
        const diffDate = moment().diff(moment(res), 'minute')
        if (diffDate <= timeout) {
          lookupDB.getItem(ERPLOOKUPKEY).then(res => {
            if (res && res.length) {
              window.__ERPLOOKUP__ = res
              window._apm && window._apm('captureException', new Error('【ERP】:lookup error, use cache'))
            }
          })
        } else {
          window._apm && window._apm('captureException', new Error(`【ERP】:lookup error, timeout ${timeout} minute`))
        }
      })
    }
  } catch (error) {
    window._apm && window._apm('captureException', new Error(`【ERP】: hasLookUpInWindow catch, ${error}`))
  }
}

hasLookUpInWindow()




// WEBPACK FOOTER //
// ./src/layout/layout/setup/lookup-cache.js